module.exports = __webpack_public_path__ + "static/media/womens-health-channel-badge.96a5a509.png";